<div class="card papernote-wrap">
  <div class="card-header card-no-border">
    <div class="header-top">
      <h5>PaperNote</h5>
      <a class="f-light d-flex align-items-center" href="#">View project <i class="f-w-700 icon-arrow-top-right"></i></a>
    </div>
  </div>
  <div class="card-body pt-0">
    <img class="banner-img img-fluid" src="assets/images/dashboard/papernote.jpg" alt="multicolor background" />
    <div class="note-content mt-sm-4 mt-2">
      <p>Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit.</p>
      <div class="note-labels">
        <ul>
          <li><span class="badge badge-light-primary">SAAS</span></li>
          <li><span class="badge badge-light-success">E-Commerce</span></li>
          <li><span class="badge badge-light-warning">Crypto</span></li>
          <li><span class="badge badge-light-info">Project</span></li>
          <li><span class="badge badge-light-secondary">NFT</span></li>
          <li><span class="badge badge-light-light">+9</span></li>
        </ul>
        <div class="last-label"><span class="badge badge-light-success">Inprogress</span></div>
      </div>
      <div class="mt-sm-4 mt-2 user-details">
        <div class="customers">
          <ul>
            <li class="d-inline-block"><img class="img-40 rounded-circle" src="assets/images/dashboard/user/1.jpg" alt="user" /></li>
            <li class="d-inline-block"><img class="img-40 rounded-circle" src="assets/images/dashboard/user/6.jpg" alt="user" /></li>
            <li class="d-inline-block"><img class="img-40 rounded-circle" src="assets/images/dashboard/user/7.jpg" alt="user" /></li>
            <li class="d-inline-block"><img class="img-40 rounded-circle" src="assets/images/dashboard/user/3.jpg" alt="user" /></li>
            <li class="d-inline-block"><img class="img-40 rounded-circle" src="assets/images/dashboard/user/8.jpg" alt="user" /></li>
            <li class="d-inline-block">
              <div class="light-card"><span class="f-w-500">+5</span></div>
            </li>
          </ul>
        </div>
        <div class="d-flex align-items-center">
          <h5 class="mb-0 font-primary f-18 me-1">$239,098</h5>
          <span class="f-light f-w-500">(Budget)</span>
        </div>
      </div>
    </div>
  </div>
</div>
